import { createStore } from '@servicetitan/financing-utils-shared';
import { useState } from 'react';

function useOfferAccepted(initialState = false) {
    const [offerAccepted, setOfferAccepted] = useState(initialState);
    return { offerAccepted, setOfferAccepted };
}

export const OfferAcceptedStore = createStore(useOfferAccepted);
